import React from "react";

interface TitleProps {
  title: string;
  subtitle: string;
}

const Title: React.FC<TitleProps> = ({ title, subtitle }) => (
  <div className="mb-4">
    <h2 className="font-ubuntu text-[26px] font-medium">{title}</h2>
    <p className="font-ubuntu text-base font-normal my-2">{subtitle}</p>
  </div>
);

export default Title;
